import React from 'react'
import { Navigation, Pagination } from 'swiper/modules'
import { Swiper, SwiperSlide } from 'swiper/react'
import 'swiper/css'
import 'swiper/css/navigation'
import 'swiper/css/pagination'

interface CampaignImageSliderProps {
    images: string[]
}

const CampaignImageSlider: React.FC<CampaignImageSliderProps> = ({ images }) => {
    if (!images.length) {
        return <div className="campaign-detail-hero__placeholder" aria-hidden />
    }

    if (images.length === 1) {
        return <img src={images[0]} alt="" className="campaign-detail-hero__img" />
    }

    return (
        <Swiper
            modules={[Pagination, Navigation]}
            pagination={{ clickable: true }}
            navigation
            className="campaign-detail-slider"
        >
            {images.map((url) => (
                <SwiperSlide key={url}>
                    <img src={url} alt="" className="campaign-detail-hero__img" />
                </SwiperSlide>
            ))}
        </Swiper>
    )
}

export default CampaignImageSlider
